import { Publication } from './publication';

export const PUBLICATION : Publication[] =  [
    {
      id: "0",
      name_ru: 'О новых находках вислых печатей князя Мстислава (Константина) Владимировича (987 – 1036 гг.)',
      centuries: ['X', 'XI'],
      authors: ['Жуков И.А.'],
      volume: 6
    },
    {
      id: "1",
      name_ru: 'Штемпель для чеканки подражаний джучидским монетам из села Селиванова Тульской области',
      centuries: ['XIV'],
      authors: ['Беспалов Р.А.'],
      volume: 6
    },
    {
      id: "2",
      name_ru: 'Полуденги великого князя Василия Дмитриевича, чеканенные в Переславле-Залесском',
      centuries: ['XIV', 'XV'],
      authors: ['Титов Г.А.'],
      volume: 6
    },
    {
      id: "3",
      name_ru: 'Монетная чеканка Маджара рубежа 780-790 гг.х.',
      centuries: ['XIV'],
      authors: ["Ермолов Ф.В.", "Добромыслов Л.Б."],
      volume: 6
    },
    {
      id: "4",
      name_ru: 'Переславские денги литовского князя Дмитрия Ольгердовича',
      centuries: ['XIV'],
      authors: ["Зайцев В.В."],
      volume: 6
    },
    {
      id: "5",
      name_ru: 'О кладе монет с полуполтинами 1654 г. из Смоленской области',
      centuries: ['XVII'],
      authors: ["Зайцев В.В."],
      volume: 6
    },
    {
      id: "6",
      name_ru: 'О подражаниях куфическим дирхемам Краснодворского клада монет X в.',
      centuries: ['X'],
      authors: ["Гоглов С.А.", "Лебедев В.П.", "Шинаков Е.А."],
      volume: 7
    },
    {
      id: "7",
      name_ru: 'Находки средневековых свинцовых пломб близ летописного Друцка',
      centuries: ['XI', 'XII'],
      authors: ["Гулецкий Д.В."],
      volume: 2
    },
    {
      id: "8",
      name_ru: 'Об атрибуции вислых печатей Полоцкого княжества XI–XII вв.',
      centuries: ['XI', 'XII'],
      authors: ["Жуков И.А."],
      volume: 2
    },
    {
      id: "9",
      name_ru: 'Монетная гривна из Владимир-Волынского района Волынской области Украины',
      centuries: ['XIII'],
      authors: ["Гулецкий Д.В.", "Зайончковский Ю.В."],
      volume: 2
    },
    {
      id: "10",
      name_ru: 'Выпуски дангов начального периода правления хана Золотой Орды Мухаммеда (771–772 г.х.)',
      centuries: ['XIV'],
      authors: ["Булава Л.Н.", "Шевчук А.А."],
      volume: 2
    },
    {
      id: "11",
      name_ru: 'Практика экспорта штемпелей монетного двора Сарай ал-Джадида при хане Токтамыше. Часть 2. Монетная мастерская Орда ал-Джадида',
      centuries: ['XIV'],
      authors: ["Ермолов Ф.В.", "Добромыслов Л.Б."],
      volume: 2
    },
    {
      id: "12",
      name_ru: 'К вопросу о чеканке подражаний джучидским дангам в Приупье, верховьях Оки и Дона',
      centuries: ['XIV'],
      authors: ["Павлюков В.В."],
      volume: 2
    },
    {
      id: "13",
      name_ru: 'Геральдические символы Смоленского княжества на смоленских монетах конца XIV — начала XV в.',
      centuries: ['XIV', 'XV'],
      authors: ["Марков В.В."],
      volume: 2
    },
    {
      id: "14",
      name_ru: 'К истории раннего периода денежного чекана Ярославского княжества',
      centuries: ['XV'],
      authors: ["Зайцев В.В.", "Титов Г.А.", "Михайленко О.В."],
      volume: 2
    },
    {
      id: "15",
      name_ru: 'Монеты Ивана Борисовича Нижегородского второго десятилетия XV в.',
      centuries: ['XV'],
      authors: ["Волков И.В."],
      volume: 2
    },
    {
      id: "16",
      name_ru: 'Об одной группе монет с именем князя Фёдора',
      centuries: ['XV'],
      authors: ["Титов Г.А."],
      volume: 2
    },
    {
      id: "17",
      name_ru: 'Данги джучидского хана Дервиша чекана Орду',
      centuries: ['XV'],
      authors: ["Зайончковский Ю.В."],
      volume: 2
    },
    {
      id: "18",
      name_ru: 'Клад начала 1420-х гг. из Тульской области',
      centuries: ['XV'],
      authors: ["Зайончковский Ю.В.", "Гулецкий Д.В.", "Петрунин К.М."],
      volume: 2
    },
    {
      id: "19",
      name_ru: 'О типе денги Великого княжества Московского со сценой убиения «беса»',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А.", "Шулепко М.И."],
      volume: 2
    },
    {
      id: "20",
      name_ru: 'О типе денег Великого княжества Московского со всадником с копьем и строчной надписью',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А.", "Шулепко М.И."],
      volume: 2
    },
    {
      id: "21",
      name_ru: 'О «переходном» типе денег раннего периода правления Василия Тёмного',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А.", "Шулепко М.И."],
      volume: 2
    },
    {
      id: "22",
      name_ru: 'О монетном чекане князя Дмитрия Юрьевича Шемяки',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А."],
      volume: 2
    },
    {
      id: "23",
      name_ru: 'Клад русских монет 1440-х гг. из Владимирской области',
      centuries: ['XV'],
      authors: ["Волков И.В."],
      volume: 2
    },
    {
      id: "24",
      name_ru: 'Новый тип монет Ярославского княжества (40-е гг. XV в.)',
      centuries: ['XV'],
      authors: ["Зайцев В.В.", "Титов Г.А."],
      volume: 2
    },
    {
      id: "25",
      name_ru: 'Новые находки восточных монет XIV–XVI веков на территории современной Беларуси',
      centuries: ['XIV', 'XV', 'XVI'],
      authors: ["Горбань П.И."],
      volume: 2
    },
    {
      id: "26",
      name_ru: 'Особенности исследования металла средневековых монет из билона',
      centuries: ['technology'],
      authors: ["Морозов А.А."],
      volume: 2
    },
    {
      id: "27",
      name_ru: 'О месте и времени чеканки копеек Ивана Грозного',
      centuries: ['XVI'],
      authors: ["Сарайкин А.С."],
      volume: 2
    },
    {
      id: "28",
      name_ru: 'Западноевропейская товарная пломба из Королевства Дания. Определение. Назначение',
      centuries: ['XVII'],
      authors: ["Тигунцев Ю.Г."],
      volume: 2
    },
    {
      id: "29",
      name_ru: 'К проблемам атрибуции псковских медных копеек середины XVII века',
      centuries: ['XVII'],
      authors: ["Сарайкин А.С.", "Шатохин Г.Г."],
      volume: 2
    },
    {
      id: "30",
      name_ru: 'Документы и нумизматика Великого Княжества Литовского (конец XV – первая половина XVI вв.): ошибки исследователей (часть 2)',
      centuries: ['XV', 'XVI'],
      authors: ["Карач А.В."],
      volume: 2
    },
    {
      id: "31",
      name_ru: 'О ряде сфрагистических находок периода Киевской Руси по данным сети Интернет',
      centuries: ['XI', 'XII'],
      authors: ["Боркевич Г.С."],
      volume: 2
    },
    {
      id: "32",
      name_ru: 'Уникальная вислая печать смоленского князя Юрия Святославича (1401–1404 гг.)',
      centuries: ['XV'],
      authors: ["Жуков И.А."],
      volume: 2
    },
    {
      id: "33",
      name_ru: 'Комплекс джучидских дангов второй половины XIV века из Черкасской области',
      centuries: ['XIV'],
      authors: ["Булава Л.Н.", "Ларионов Ю.В."],
      volume: 2
    },
    {
      id: "34",
      name_ru: 'Новый тип денги Василия Дмитриевича Московского',
      centuries: ['XV'],
      authors: ["Михайленко О.В.", "Титов Г.А."],
      volume: 2
    },
    {
      id: "35",
      name_ru: 'Новый тип полуденги князя Андрея Дмитриевича Можайского',
      centuries: ['XV'],
      authors: ["Михайленко О.В."],
      volume: 2
    },
    {
      id: "36",
      name_ru: 'Два комплекса первой половины XVII в. из-под села Фалелеево Переславль-Залесского района Ярославской области',
      centuries: ['XVII'],
      authors: ["Романов С.Ю."],
      volume: 2
    },
    {
      id: "37",
      name_ru: 'О монетном чекане Волжской Булгарии X в.',
      centuries: ['X'],
      authors: ["Гоглов С.А.", "Големихов А.В."],
      volume: 3
    },
    {
      id: "38",
      name_ru: 'О Безлюдовском кладе монет X в.',
      centuries: ['X'],
      authors: ["Гоглов С.А."],
      volume: 3
    },
    {
      id: "39",
      name_ru: 'Возникновение денежного дела Норвегии в эпоху викингов: серебряные пеннинги короля Улава I Триггвасона (995-1000)',
      centuries: ['X'],
      authors: ["Петров А.Н."],
      volume: 3
    },
    {
      id: "40",
      name_ru: 'К атрибуции личных княжеских знаков Рюриковичей второй половины XI века',
      centuries: ['XI'],
      authors: ["Сорокин И.Ю."],
      volume: 3
    },
    {
      id: "41",
      name_ru: 'Вислые печати великого князя Владимира (Василия) Всеволодовича Мономаха (1066 – 1125)',
      centuries: ['XI', 'XII'],
      authors: ["Жуков И.А."],
      volume: 3
    },
    {
      id: "42",
      name_ru: 'Вислые печати князя Святополка (Михаила) Изяславича (1064 – 1113), княгинь Елены и Ирины',
      centuries: ['XI', 'XII'],
      authors: ["Жуков И.А."],
      volume: 3
    },
    {
      id: "43",
      name_ru: 'Свинцовые пломбы XI - XII вв. с изображением святых и креста различных типов из северо-западной части Черниговской земли и Мстиславского удела Смоленской земли Киевской Руси (по сборам в Брянской области)',
      centuries: ['XI', 'XII'],
      authors: ["Тигунцев Ю.Г.", "Гулецкий Д.В."],
      volume: 3
    },
    {
      id: "44",
      name_ru: 'Второй Друцкий комплекс свинцовых пломб',
      centuries: ['XI', 'XII', 'XIII'],
      authors: ["Гулецкий Д.В."],
      volume: 3
    },
    {
      id: "45",
      name_ru: 'Заказчики строительства Борисоглебских соборов в Смоленске и Чернигове и возводившие их мастера',
      centuries: ['XII'],
      authors: ["Марков В.В."],
      volume: 3
    },
    {
      id: "46",
      name_ru: 'Малая сфрагистика Галицко-Волынской земли II половины XII – XIII веков: находки последних лет',
      centuries: ['XII', 'XIII'],
      authors: ["Боркевич Г.С.", "Ярошевский Н.А."],
      volume: 3
    },
    {
      id: "47",
      name_ru: 'Церковь Параскевы Пятницы и Пятницкий конец Смоленска в XII – XIII вв.',
      centuries: ['XII', 'XIII'],
      authors: ["Марков В.В."],
      volume: 3
    },
    {
      id: "48",
      name_ru: 'Новомосковский комплекс дангов Токтамыша',
      centuries: ['XIV'],
      authors: ["Зайончковский Ю.В.", "Губа К.А.", "Тишкин В.Е."],
      volume: 4
    },
    {
      id: "49",
      name_ru: 'Атрибуция актовых печатей первого полоцкого князя Рогволода',
      centuries: ['X'],
      authors: ["Петров А.Н.", "Гулецкий Д.В."],
      volume: 4
    },
    {
      id: "50",
      name_ru: 'Еще раз о денежном счете домонгольской Руси',
      centuries: ['X', 'XI', 'XII', 'XIII'],
      authors: ["Гулецкий Д.В."],
      volume: 4
    },
    {
      id: "51",
      name_ru: 'Две заметки о платёжных слитках русского средневековья',
      centuries: ['XIII', 'XIV'],
      authors: ["Гулецкий Д.В."],
      volume: 4
    },
    {
      id: "52",
      name_ru: 'Об атрибуции вислых печатей великих князей Владимирских (первая половина XIII в.)',
      centuries: ['XIII'],
      authors: ["Жуков И.А."],
      volume: 4
    },
    {
      id: "53",
      name_ru: 'Вислые печати князя Александра Ярославича Невского. 1228-1263 гг.',
      centuries: ['XIII'],
      authors: ["Жуков И.А."],
      volume: 4
    },
    {
      id: "54",
      name_ru: 'Серебряные гривны из собрания Национального Музея в Варшаве',
      centuries: ['XIII', 'XIV'],
      authors: ["Шталенков И.Н."],
      volume: 4
    },
    {
      id: "55",
      name_ru: 'Чекан дангов хана Мухаммеда монетного двора Орда 772-773 гг.х. Часть 1 (772 г.х.)',
      centuries: ['XIV'],
      authors: ["Шевчук А.А.", "Булава Л.Н."],
      volume: 4
    },
    {
      id: "56",
      name_ru: 'Клад дангов из окрестностей Азова начала 1370-х годов',
      centuries: ['XIV'],
      authors: ["Булава Л.Н.", "Шевчук А.А."],
      volume: 4
    },
    {
      id: "57",
      name_ru: 'Об одном из ранних типов надчеканок Великого княжества Московского',
      centuries: ['XIV'],
      authors: ["Амосов М.А."],
      volume: 4
    },
    {
      id: "58",
      name_ru: 'Практика экспорта монетных штемпелей Сарай ал-Джедида при хане Токтамыше. Часть 3',
      centuries: ['XIV'],
      authors: ["Ермолов Ф.В.", "Добромыслов Л.Б."],
      volume: 4
    },
    {
      id: "59",
      name_ru: 'О происхождении весовой нормы ранних денег Великого княжества Московского',
      centuries: ['XIV'],
      authors: ["Зайцев В.В."],
      volume: 4
    },
    {
      id: "60",
      name_ru: 'Новый тип анонимных денег Великого княжества Московского',
      centuries: ['XIV'],
      authors: ["Титов Г.А.", "Орлов К.В."],
      volume: 4
    },
    {
      id: "61",
      name_ru: 'Об одном типе денег князя Андрея Дмитриевича Можайского',
      centuries: ['XIV'],
      authors: ["Орлов К.В.", "Титов Г.А."],
      volume: 4
    },
    {
      id: "62",
      name_ru: 'Группа монет с надписью «ФЕДОТОВА» из Соболевского комплекса 1408-1410 гг.',
      centuries: ['XV'],
      authors: ["Романов С.Ю."],
      volume: 4
    },
    {
      id: "63",
      name_ru: 'Берёзовский комплекс джучидских дангов и подражаний, тезаврированный в начале правления хана Пулада',
      centuries: ['XV'],
      authors: ["Тишкин В.Е.", "Зайончковский Ю.В."],
      volume: 4
    },
    {
      id: "64",
      name_ru: 'Полуденга Ярославского княжества',
      centuries: ['XV'],
      authors: ["Титов Г.А."],
      volume: 4
    },
    {
      id: "65",
      name_ru: 'О раннем пореформенном типе денег Василия Дмитриевича Московского со всадником с мечом',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А."],
      volume: 4
    },
    {
      id: "66",
      name_ru: 'О некоторых разновидностях денег Василия I с изображением двуногого дракона',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А."],
      volume: 4
    },
    {
      id: "67",
      name_ru: 'Несколько редких и неописанных монет из находок в Наро-Фоминском районе Московской области',
      centuries: ['XV'],
      authors: ["Зайцев В.В."],
      volume: 4
    },
    {
      id: "68",
      name_ru: 'О некоторых типах денег Московского княжества 1420-30-х годов с изображением всадника с копьем',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А.", "Шулепко М.И."],
      volume: 4
    },
    {
      id: "69",
      name_ru: 'Джучидский хан Абу-л-Хайр и его монеты',
      centuries: ['XV'],
      authors: ["Зайончковский Ю.В."],
      volume: 4
    },
    {
      id: "70",
      name_ru: 'К вопросу о названии номинала серебряных монет Золотой Орды в XV в.',
      centuries: ['XV'],
      authors: ["Зайончковский Ю.В."],
      volume: 4
    },
    {
      id: "71",
      name_ru: 'Монеты XV века с солярным знаком',
      centuries: ['XV'],
      authors: ["Бугарчёв А.И."],
      volume: 4
    },
    {
      id: "72",
      name_ru: 'Надчеканка монеты в Молдавии и Литве в первой половине XV в. по данным клада из украинского села Стижок',
      centuries: ['XV'],
      authors: ["Дергачёва Л.В.", "Петров А.Н."],
      volume: 4
    },
    {
      id: "73",
      name_ru: 'Исследования состава металла методом РФА и реконструкция структуры монетного чекана в Крымском ханстве при Сахиб Гирае I',
      centuries: ['XVI'],
      authors: ["Морозов А.А."],
      volume: 4
    },
    {
      id: "74",
      name_ru: 'Новгородские монеты периода правления Бориса Годунова',
      centuries: ['XVII'],
      authors: ["Савченко А.С."],
      volume: 4
    },
    {
      id: "75",
      name_ru: 'Новые находки монетных комплексов XVII в. из Центральной России',
      centuries: ['XVII'],
      authors: ["Романов С.Ю."],
      volume: 4
    },
    {
      id: "76",
      name_ru: 'Два клада медных монет Алексея Михайловича',
      centuries: ['XVII'],
      authors: ["Сарайкин А.С.", "Шатохин Г.Г."],
      volume: 4
    },
    {
      id: "77",
      name_ru: 'О пуансонной технике изготовления штемпелей группы восточноевропейских куфических подражаний на рубеже IX – X вв.',
      centuries: ['IX', 'X'],
      authors: ['Големихов А.В.'],
      volume: 6
    },
    {
      id: "78",
      name_ru: 'Об односторонних куфических монетах X века из восточноевропейских находок',
      centuries: ['X'],
      authors: ['Гоглов С.А.'],
      volume: 6
    },
    {
      id: "79",
      name_ru: 'Весовой комплекс середины X – начала XI вв. для взвешивания ценностей из Брянской области',
      centuries: ['X', 'XI'],
      authors: ['Тигунцев Ю.Г.'],
      volume: 6
    },
    {
      id: "80",
      name_ru: 'Монетный комплекс X века из Владимирской области',
      centuries: ['X'],
      authors: ["Гоглов С.А."],
      volume: 6
    },
    {
      id: "81",
      name_ru: 'Печати протопроэдра Евстафия',
      centuries: ['XI'],
      authors: ["Гаев А.Г."],
      volume: 6
    },
    {
      id: "82",
      name_ru: 'Палеографические черты вислых актовых печатей сфрагистического типа «Господне слово» XI – XII вв.',
      centuries: ['XI', 'XII'],
      authors: ["Петров А.Н.", "Гулецкий Д.В."],
      volume: 6
    },
    {
      id: "83",
      name_ru: 'Датировка новгородских замков-цилиндров со знаками Рюриковичей по данным сфрагистики',
      centuries: ['XI', 'XII'],
      authors: ["Сорокин И.Ю."],
      volume: 6
    },
    {
      id: "84",
      name_ru: 'Чекан дангов хана Мухаммеда монетного двора Орду в 774 –776 г.х.',
      centuries: ['XIV'],
      authors: ["Шевчук А.А.", "Булава Л.Н."],
      volume: 6
    },
    {
      id: "85",
      name_ru: 'Клад трёхгранных рублей из окрестностей Речицы',
      centuries: ['XV'],
      authors: ["Гулецкий Д.В.", "Филь А.В."],
      volume: 6
    },
    {
      id: "86",
      name_ru: 'Смоленск и его окрестности в XIV – XV вв. по данным нумизматики, археологии и письменным источникам',
      centuries: ['XIV', 'XV'],
      authors: ["Марков В.В."],
      volume: 6
    },
    {
      id: "87",
      name_ru: 'Позднеджучидские северокавказские монеты с изображением шестилепесткового цветка',
      centuries: ['XV'],
      authors: ["Леонов Б.И.", "Зайончковский Ю.В."],
      volume: 6
    },
    {
      id: "88",
      name_ru: 'Комплекс подражаний с берега реки Лея',
      centuries: ['XV'],
      authors: ["Зайончковский Ю.В."],
      volume: 6
    },
    {
      id: "89",
      name_ru: 'Новые находки северских подражаний с «княжеским знаком»',
      centuries: ['XIV'],
      authors: ["Шапошник В.Г.", "Зайончковский Ю.В."],
      volume: 6
    },
    {
      id: "90",
      name_ru: 'Новый тип медных монет из Коломны',
      centuries: ['XV'],
      authors: ["Амосов М.А."],
      volume: 6
    },
    {
      id: "91",
      name_ru: 'Комплекс русских монет начала 1420-х гг. из Ардатовского района Нижегородской области',
      centuries: ['XV'],
      authors: ["Титов Г.А.", "Шулепко М.И."],
      volume: 6
    },
    {
      id: "92",
      name_ru: 'Клад монет второй четверти XV в. из Кайбицкого района Республики Татарстан',
      centuries: ['XV'],
      authors: ["Купцов А.Е.", "Бугарчёв А.И."],
      volume: 6
    },
    {
      id: "93",
      name_ru: 'О типе денег Михаила Андреевича Верейского «Русская легенда / всадник с занесенным мечом»',
      centuries: ['XV'],
      authors: ["Родионов А.С."],
      volume: 6
    },
    {
      id: "94",
      name_ru: 'Группа тверских монет Великого князя Ивана с изображением сокольника',
      centuries: ['XV'],
      authors: ["Волков И.В.", "Лейбов В.Л."],
      volume: 6
    },
    {
      id: "95",
      name_ru: '«Новгородский денежный двор» или «новгородские денежные дворы» при Иване III?',
      centuries: ['XV', 'XVI'],
      authors: ["Волков И.В."],
      volume: 6
    },
    {
      id: "96",
      name_ru: 'Неописанный литовский полугрош Александра Ягеллона с уникальным типом реверса',
      centuries: ['XV', 'XVI'],
      authors: ["Громыко А.А."],
      volume: 6
    },
    {
      id: "97",
      name_ru: 'Крупный Мазеповский клад обрезанных дирхемов середины X в. из Курской области',
      centuries: ['X'],
      authors: ["Лебедев В.П.", "Орлов А.С.", "Гоглов С.А.", "Климов А.М."],
      volume: 7
    },
    {
      id: "98",
      name_ru: 'Находка подражания золотому солиду Льва III и Константина V в. Крымском районе Краснодарского Края',
      centuries: ['IX'],
      authors: ["Рублев А.И."],
      volume: 7
    },
    {
      id: "99",
      name_ru: 'О куфическом подражании с именем Ахмада б. Абдаллаха',
      centuries: ['X'],
      authors: ["Гоглов С.А.", "Големихов А.В."],
      volume: 7
    },
    {
      id: "100",
      name_ru: 'Об атрибуции вислых печатей новгородского князя Глеба Святославича (1069–1078 гг.)',
      centuries: ['XI'],
      authors: ["Жуков И.А."],
      volume: 7
    },
    {
      id: "101",
      name_ru: 'Знаки Рюриковичей второй половины XI – XII вв. (дополнения к атрибуциям)',
      centuries: ['XI', 'XII'],
      authors: ["Сорокин И.Ю."],
      volume: 7
    },
    {
      id: "102",
      name_ru: 'Древнерусские вислые печати: украинские находки, зафиксированные в 2017 г. Часть 1. Печати второй половины XI – первой половины XII в.',
      centuries: ['XI', 'XII'],
      authors: ["Ярошевский Н.А.", "Боркевич Г.С."],
      volume: 7
    },
    {
      id: "103",
      name_ru: 'О находках древнерусских свинцовых пломб XI–XIII вв. на юго-западе Полоцкой земли и в пределах Туровской земли',
      centuries: ['XI', 'XII', 'XIII'],
      authors: ["Гулецкий Д.В.", "Богуш А.К."],
      volume: 7
    },
    {
      id: "104",
      name_ru: 'Новые атрибуции древнерусских вислых печатей духовенства',
      centuries: ['XII'],
      authors: ["Гаев А.Г."],
      volume: 7
    },
    {
      id: "105",
      name_ru: 'Княжеские вислые печати второй половины XIII – первой четверти XIV в.',
      centuries: ['XIII', 'XIV'],
      authors: ["Жуков И.А."],
      volume: 7
    },
    {
      id: "106",
      name_ru: 'Легенды Бессарабии. К вопросу прочтения легенд на медных монетах из ордынского монетного двора в с. Костешты-Гырля (Республика Молдова)',
      centuries: ['XIV'],
      authors: ["Петров А.Н."],
      volume: 7
    },
    {
      id: "107",
      name_ru: 'Комплекс поздних киевских подражаний дангам Джанибека из-под с. Черногородка',
      centuries: ['XIV'],
      authors: ["Горбань П.И.", "Гулецкий Д.В."],
      volume: 7
    },
    {
      id: "108",
      name_ru: 'Серебряный чекан Маджара и Орды периода 794–797 гг. х.',
      centuries: ['XIV'],
      authors: ["Ермолов Ф.В.", "Добромыслов Л.Б."],
      volume: 7
    },
    {
      id: "109",
      name_ru: 'Ранние волго-окские подражания',
      centuries: ['XIV'],
      authors: ["Кудрин А.А."],
      volume: 7
    },
    {
      id: "110",
      name_ru: 'Клад платежных слитков-полтин из Смоленской области',
      centuries: ['XIV'],
      authors: ["Зайцев В.В.", "Романов С.Ю."],
      volume: 7
    },
    {
      id: "111",
      name_ru: 'Об одном необычном типе русских средневековых монет',
      centuries: ['XV'],
      authors: ["Михайленко О.В."],
      volume: 7
    },
    {
      id: "112",
      name_ru: 'Об одном пореформенном типе денег Василия Дмитриевича Московского с двусторонним подражанием арабской надписи',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А."],
      volume: 7
    },
    {
      id: "113",
      name_ru: 'Еще раз о денгах Василия I с изображением крылатого животного',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А."],
      volume: 7
    },
    {
      id: "114",
      name_ru: 'Новый клад монет XV в. из окрестностей села Большие Атряси (Тетюшский район Татарстана)',
      centuries: ['XV'],
      authors: ["Степанов О.В."],
      volume: 7
    },
    {
      id: "115",
      name_ru: 'Владельческая печать-матрица 1480-х – 1496 гг. из Ивангорода: гипотеза о происхождении и владельце',
      centuries: ['XV'],
      authors: ["Романов С.Ю."],
      volume: 7
    },
    {
      id: "116",
      name_ru: 'Комплекс пул конца XV в. из Ярославской области',
      centuries: ['XV'],
      authors: ["Зайцев В.В.", "Бадретдинов Н.Н."],
      volume: 7
    },
    {
      id: "117",
      name_ru: 'Медные монеты новгородской чеканки XV–XVI вв.',
      centuries: ['XV', 'XVI'],
      authors: ["Зайцев В.В."],
      volume: 7
    },
    {
      id: "118",
      name_ru: 'О литовском полугроше 1508 г.',
      centuries: ['XVI'],
      authors: ["Каваляускас В."],
      volume: 7
    },
    {
      id: "119",
      name_ru: 'К вопросу о начале чеканки Девлета Гирая I',
      centuries: ['XVI'],
      authors: ["Морозов А.А."],
      volume: 7
    },
    {
      id: "120",
      name_ru: 'Клад серебряных монет XVI в. из раскопок селища Савельево в Московской области',
      centuries: ['XVI'],
      authors: ["Зайцев В.В.", "Прошкин О.Л."],
      volume: 7
    },
    {
      id: "121",
      name_ru: 'К проблемам атрибуции некоторых псковских копеек периода правления царя Федора Ивановича',
      centuries: ['XVI'],
      authors: ["Савченко А.С."],
      volume: 7
    },
    {
      id: "122",
      name_ru: 'Некоторые новые находки комплексов и отдельных монет XVI – начала XVII в.',
      centuries: ['XVI', 'XVII'],
      authors: ["Моряков А.В."],
      volume: 7
    },
    {
      id: "123",
      name_ru: 'Клад западноевропейских монет XVII в., найденный близ г. Коростышева Житомирской области. Материалы к сводке кладов западноевропейских монет XVI–XVII вв. в собрании ОН ГИМ',
      centuries: ['XVI', 'XVII'],
      authors: ["Ушанков Е.М."],
      volume: 7
    },
    {
      id: "124",
      name_ru: 'Полуденги Василия Дмитриевича Московского конца XIV – начала XV в., чеканенные в Переславле-Залесском (уточнения и дополнения)',
      centuries: ['XIV', 'XV'],
      authors: ["Титов Г.А."],
      volume: 7
    },
    {
      id: "125",
      name_ru: 'Вислые печати Полоцкого князя Рогволода (Василия) Борисовича (1144 - 1151, 1159 - 1162) и его жены, княгини Олины',
      centuries: ['XII'],
      authors: ["Жуков И.А."],
      volume: 1
    },
    {
      id: "126",
      name_ru: 'И-образные и N-образные надчеканы в круглой зубчатой розетке',
      centuries: ['XIV'],
      authors: ["Беспалов Р.А."],
      volume: 1
    },
    {
      id: "127",
      name_ru: 'Вислая печать пронского князя Ивана Владимировича (конец XIV века – около 1430 г.) и его монеты',
      centuries: ['XIV', 'XV'],
      authors: ["Жуков И.А.", "Гулецкий Д.В."],
      volume: 1
    },
    {
      id: "128",
      name_ru: 'Практика экспорта штемпелей монетным двором Сарай ал-Джадид при хане Токтамыше',
      centuries: ['XIV'],
      authors: ["Ермолов Ф.В.", "Добромыслов Л.Б."],
      volume: 1
    },
    {
      id: "129",
      name_ru: 'О кустарных подделках монет Золотой Орды',
      centuries: ['XIV'],
      authors: ["Бойко-Гагарин А.С."],
      volume: 1
    },
    {
      id: "130",
      name_ru: 'Фрагмент комплекса из-под села Леськи Черкасского района Черкасской области',
      centuries: ['XIV'],
      authors: ["Зайончковский Ю.В.", "Шептуха В.П."],
      volume: 1
    },
    {
      id: "131",
      name_ru: 'Бахчисарайский клад джучидских дангов конца XIV века',
      centuries: ['XIV'],
      authors: ["Архипенко А.А.", "Зайончковский Ю.В."],
      volume: 1
    },
    {
      id: "132",
      name_ru: 'Азакские данги начала XV века',
      centuries: ['XIV'],
      authors: ["Савоста Р.Ю.", "Зайончковский Ю.В."],
      volume: 1
    },
    {
      id: "133",
      name_ru: 'Новая группа подражаний из Селивановских кладов',
      centuries: ['XIV', 'XV'],
      authors: ["Павлюков В.В."],
      volume: 1
    },
    {
      id: "134",
      name_ru: '«Портретные» монеты Василия Дмитриевича Московского',
      centuries: ['XIV'],
      authors: ["Гоглов С.А.", "Титов Г.А."],
      volume: 1
    },
    {
      id: "135",
      name_ru: 'Монеты Семена Владимировича Боровского начала второго десятилетия XV в.',
      centuries: ['XV'],
      authors: ["Волков И.В."],
      volume: 1
    },
    {
      id: "136",
      name_ru: 'Денги Василия Дмитриевича Московского с «воином-муравьем»',
      centuries: ['XV'],
      authors: ["Волков И.В.", "Гоглов С.А.", "Титов Г.А."],
      volume: 1
    },
    {
      id: "137",
      name_ru: 'К атрибуции одного из типов редких удельных монет первой половины XV в.',
      centuries: ['XV'],
      authors: ["Зайцев В.В."],
      volume: 1
    },
    {
      id: "138",
      name_ru: 'О монетах Василия Дмитриевича московского с крылатым четвероногим',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А."],
      volume: 1
    },
    {
      id: "139",
      name_ru: 'Новый тип монет Ярославского княжества',
      centuries: ['XV'],
      authors: ["Титов Г.А."],
      volume: 1
    },
    {
      id: "140",
      name_ru: 'Комплекс русских монет второй половины 1420-х годов из окрестностей поселка Добрятино Гусь-Хрустального р-на Владимирской области',
      centuries: ['XV'],
      authors: ["Гоглов С.А.", "Титов Г.А.", "Романов С.Ю."],
      volume: 1
    },
    {
      id: "141",
      name_ru: 'Гниваньский клад начала II четверти XV века',
      centuries: ['XV'],
      authors: ["Гулецкий Д.В.", "Зайончковский Ю.В."],
      volume: 1
    },
    {
      id: "142",
      name_ru: 'Лабораторные исследования монет Гниваньского клада',
      centuries: ['XV'],
      authors: ["Гулецкий Д.В.", "Ермалицкая К.Ф."],
      volume: 1
    },
    {
      id: "143",
      name_ru: 'Клад джучидских дангов XV века с берега реки Северский Донец',
      centuries: ['XV'],
      authors: ["Зайончковский Ю.В."],
      volume: 1
    },
    {
      id: "144",
      name_ru: 'Исследование стохастических свойств веса монет на примере выборки виленских полугрошей Александра Казимировича',
      centuries: ['XV', 'XVI'],
      authors: ["Тиунчик А.А.", "Гулецкий Д.В."],
      volume: 1
    },
    {
      id: "145",
      name_ru: 'История чеканки монет Литвы (1495-1536)',
      centuries: ['XV', 'XVI'],
      authors: ["Иванаускас Э."],
      volume: 1
    },
    {
      id: "146",
      name_ru: 'Документы и нумизматика ВКЛ (конец XV – первая половина XVI века): ошибки исследователей',
      centuries: ['XV', 'XVI'],
      authors: ["Карач А.В."],
      volume: 1
    },
    {
      id: "147",
      name_ru: 'О «дореформенном чекане» времени Ивана Грозного (сводный каталог монет)',
      centuries: ['XVI'],
      authors: ["Савченко А.С."],
      volume: 1
    },
    {
      id: "148",
      name_ru: 'Новый тип московского лицевого маточника времени правления Ивана Грозного',
      centuries: ['XVI'],
      authors: ["Савченко А.С."],
      volume: 1
    },
    {
      id: "149",
      name_ru: 'Некоторые редкие и неизданные медные копейки кукенойского двора',
      centuries: ['XVII'],
      authors: ["Сарайкин А.С.", "Шатохин Г.Г."],
      volume: 1
    },
    {
      id: "150",
      name_ru: 'О находках византийских печатей XI/XII вв. с именем Михаила из Давлии на территории Полоцкой земли',
      centuries: ['XI', 'XII'],
      authors: ["Гулецкий Д.В.", "Зайбт В."],
      volume: 5
    },
    {
      id: "151",
      name_ru: 'Вислые печати великого князя Мстислава (Феодора) Владимировича 1088 – 1132 годов',
      centuries: ['XI', 'XII'],
      authors: ["Жуков И.А."],
      volume: 5
    },
    {
      id: "152",
      name_ru: 'Свинцовые пломбы XI – начала XIII вв. из северо-западной части Черниговской земли и Мстиславской волости Смоленской земли (по сборам в Брянской области). Часть 2. Пломбы с изображениями знаков и литер различных типов',
      centuries: ['XI', 'XII', 'XIII'],
      authors: ["Тигунцев Ю.Г.", "Гулецкий Д.В."],
      volume: 5
    },
    {
      id: "153",
      name_ru: 'Древнерусские свинцовые пломбы с властной символикой Рюриковичей: история и проблемы изучения (по данным украинских находок последних лет)',
      centuries: ['XI', 'XII', 'XIII'],
      authors: ["Гулецкий Д.В.", "Ярошевский Н.А."],
      volume: 5
    },
    {
      id: "154",
      name_ru: 'Денежные пломбы полоцких князей XI-XII веков',
      centuries: ['XI', 'XII'],
      authors: ["Гулецкий Д.В.", "Дорошкевич Н.А."],
      volume: 5
    },
    {
      id: "155",
      name_ru: 'О новых находках именных вислых печатей иерархов русской церкви (XII век)',
      centuries: ['XII'],
      authors: ["Жуков И.А."],
      volume: 5
    },
    {
      id: "156",
      name_ru: 'Новые находки западноевропейских товарных пломб в Восточной Европе',
      centuries: ['XV', 'XVI', 'XVII'],
      authors: ["Ван Лаэре Р.", "Гулецкий Д.В."],
      volume: 5
    }
    ,
    {
      id: "157",
      name_ru: '«Полоцкий матриархат» академика В.Л. Янина и современное состояние изучения вислых печатей к актам XI-XII вв.',
      centuries: ['XII'],
      authors: ["Петров А.Н.", "Гулецкий Д.В."],
      volume: 8
    }
    ,
    {
      id: "158",
      name_ru: '«Эпоха ювелиров»: обзор обращения иностранных монет в Норвегии в II-X вв.',
      centuries: ['IX', 'X'],
      authors: ["Петров А.Н."],
      volume: 8
    }
    ,
    {
      id: "159",
      name_ru: 'Киевские князья Аскольд и Дир - выходцы с о. Готланд? Первое упоминание Смоленска в Устюжском летописном своде',
      centuries: ['IX'],
      authors: ["Марков В.В."],
      volume: 8
    },
    {
      id: "160",
      name_ru: 'Новый монетовидный материал конца X – начала XI века из северо-западной части Черниговской земли (по сборам в Брянской области)',
      centuries: ['X', 'XI'],
      authors: ["Тигунцев Ю.Г.", "Соболев В.В."],
      volume: 8
    },
    {
      id: "161",
      name_ru: 'О новых находках вислых печатей витебской княгини Софии (Евдоксии)',
      centuries: ['XII'],
      authors: ["Жуков И.А."],
      volume: 8
    },
    {
      id: "162",
      name_ru: 'Находки древнерусских свинцовых пломб XI-XIII вв. на территории былой Логожской волости',
      centuries: ['XI', 'XII', 'XIII'],
      authors: ["Богуш А.К.", "Гулецкий Д.В."],
      volume: 8
    },
    {
      id: "163",
      name_ru: 'Древнерусские свинцовые пломбы XI-XIV веков по новым находкам в Беларуси',
      centuries: ['XI', 'XII', 'XIII', 'XIV'],
      authors: ["Богуш А.К."],
      volume: 8
    },
    {
      id: "164",
      name_ru: 'Византийские монеты IХ-ХI вв. в находках из юго-западных районов Брянской области',
      centuries: ['IX', 'X', 'XI'],
      authors: ["Тигунцев Ю.Г.", "Соболев В.В."],
      volume: 3
    },
  {
    id: "165",
    name_ru: 'Торговая пломба XII века с русской надписью ПАВЪ[ЛЪ]',
    centuries: ['XII'],
    authors: ["Нисифоров А.Н."],
    volume: 8
  },
      {
        id: "166",
        name_ru: 'Hoards with tenth-century dirhams found or published in eastern Europe in 1990-2014',
        centuries: ['X'],
        authors: ["Лебедев В.П."],
        volume: 9
      },
      {
        id: "167",
        name_ru: 'Die chain of Kufic imitations GGI-C18',
        centuries: ['X'],
        authors: ["Гоглов С.А.", "Големихов А.В."],
        volume: 9
      },
      {
        id: "168",
        name_ru: 'Finances and trade of Ancient Rus’: Fur money in the context of theory and practices of fiat emissions in the 11th-12th centuries',
        centuries: ['XI', 'XII'],
        authors: ["Гулецкий Д.В.", "Петров А.Н."],
        volume: 9
      },
        {
          id: "169",
          name_ru: 'Bullae of the 11th-12th centuries: recent finds in Belarus',
          centuries: ['XI', 'XII'],
          authors: ["Богуш А.К."],
          volume: 9
        },
        {
            id: "170",
            name_ru: 'A Bulgarian coin found in L’viv and remarks on monetary circulation in Halych-Volhynian Ruthenia in the thirteenth and fourteenth century',
            centuries: ['XIII', 'XIV'],
            authors: ["Пашкевич Б."],
            volume: 9
          },
        {
          id: "171",
          name_ru: 'Influence of the Golden Horde on early coins of Grand Duchy of Lithuania (GDL) in 1380–1400',
          centuries: ['XIV'],
          authors: ["Майгис Ж."],
          volume: 9
        },
        {
            id: "172",
            name_ru: 'Coin hoard from Labanoras in Lithuania',
            centuries: ['XV'],
            authors: ["Милейски П."],
            volume: 9
          },
        {
          id: "173",
          name_ru: '\"Forsake the foolish, and live...\"',
          centuries: ['XV'],
          authors: ["Гоглов С.А.", "Титов Г.А."],
          volume: 9
        },
        {
          id: "174",
          name_ru: 'The main stages of the all-Russian monetary system formation (second half of the 15th – early 16th centuries)',
          centuries: ['XV', 'XVI'],
          authors: ["Зайцев В.В."],
          volume: 9
        },
        {
          id: "175",
          name_ru: 'Finds of European lead seals of the late Jagiellonian time in Druck and Novaharodak regions of the former Grand Duchy of Lithuania',
          centuries: ['XV', 'XVI'],
          authors: ["Гулецкий Д.В.", "Ван Лаэре Р."],
          volume: 9
        },
          {
              id: "176",
              name_ru: 'Helping numismatic research',
              centuries: ['XV', 'XVI', 'XVII'],
              authors: ["Берглунд А."],
              volume: 9
            },
          {
              id: "177",
              name_ru: 'Вислые печати князя Ярополка (Ивана) Владимировича (1082-1139) и княгини Елены Ясыни',
              centuries: ['XI', 'XII'],
              authors: ["Жуков И.А."],
              volume: 5
            },
          {
              id: "178",
              name_ru: 'Уводзіны ў полацкую «малую сфрагістыку» другое паловы XII ст.',
              centuries: ['XII'],
              authors: ["Гулецкий Д.В.", "Богуш А.К.", "Кабак А.В."],
              volume: 10
            },
          {
              id: "179",
              name_ru: 'Атрибуция двух духовных актовых печатей',
              centuries: ['XII'],
              authors: ["Гаев А.Г."],
              volume: 10
            },
          {
              id: "180",
              name_ru: 'Скарб літоўскіх грыўняў з-пад вёскі Турэйск Шчучынскага раёна з музейных фондаў НГМ РБ',
              centuries: ['XIII', 'XIV'],
              authors: ["Крицук Р.И."],
              volume: 10
            }
            ,
          {
              id: "181",
              name_ru: '«Гiбрыднае» перайманне залатаардынскага данга XIV ст. са Столінскага раёна',
              centuries: ['XIV'],
              authors: ["Горбань П.И."],
              volume: 10
            },
          {
              id: "182",
              name_ru: 'Невеликий комплекс джучидських дангів 1370-х років з Кролевецького району Сумської області',
              centuries: ['XIV'],
              authors: ["Шевчук А.А.", "Булава Л.Н."],
              volume: 10
            },
          {
              id: "183",
              name_ru: 'Комплекс дангів та наслідувань XIV століття з Курського району Курської області',
              centuries: ['XIV'],
              authors: ["Зайончковский Ю.В.", "Дрокин Ю.И."],
              volume: 10
            },
          {
              id: "184",
              name_ru: 'Джучидські монети з колекції професора Сергія Георгійовича Кулешова',
              centuries: ['XIII', 'XIV'],
              authors: ["Бойко-Гагарин А.С.", "Зайончковский Ю.В."],
              volume: 10
            },
          {
              id: "185",
              name_ru: 'Рагнедзінскі комплекс смаленскіх манетаў Вітаўта',
              centuries: ['XV'],
              authors: ["Гулецкий Д.В.", "Кабак А.В.", "Петрунин К.М."],
              volume: 10
            },
          {
              id: "186",
              name_ru: 'Najstarszy skarb monet z Kowna',
              centuries: ['XV'],
              authors: ["Милейски П."],
              volume: 10
            },
          {
              id: "187",
              name_ru: 'Новый тип денги Великого княжества Московского второго десятилетия XV в.',
              centuries: ['XV'],
              authors: ["Титов Г.А.", "Агафонов С.С."],
              volume: 10
            },
          {
              id: "188",
              name_ru: 'Узоры клейнавых гербавых знакаў на матрыцах прыкладных пячатак шляхты Вялікага княства Літоўскага XV–XVI ст.',
              centuries: ['XV', 'XVI'],
              authors: ["Ретман В.В."],
              volume: 10
            },
          {
              id: "189",
              name_ru: 'Монеты Девлет-Гирая I (1550–1577) VI группы (по Ретовскому)',
              centuries: ['XVI'],
              authors: ["Морозов А.А."],
              volume: 10
            },
          {
              id: "190",
              name_ru: 'Dėl Vilniaus ir Lietuvos Brastos monetų kalyklų 1665-1666 metų LDK varinių šilingų atskyrimo klausimo',
              centuries: ['XVII'],
              authors: ["Жебраускас А.", "Каваляускас В."],
              volume: 10
            },
          {
              id: "191",
              name_ru: 'Lietuvos Didžiosios Kunigaikštystės monetos „Žvėris / Dvigubas kryžius skyde“ averso lotyniška legenda: IAGAL REX',
              centuries: ['XIV'],
              authors: ["Багдонас Г.", "Гулецкий Д.В."],
              volume: 10
            },
          {
              id: "192",
              name_ru: 'О денгах и полуденгах князя Юрия Дмитриевича Звенигородского и Галичского с изображением всадника с мечом',
              centuries: ['XIV'],
              authors: ["Орлов К.В.", "Титов Г.А."],
              volume: 10
            },
          {
              id: "193",
              name_ru: 'Клад дирхемов IX в. из Гродненской области',
              centuries: ['IX'],
              authors: ["Лебедев В.П.", "Гулецкий Д.В.", "Дорошкевич Н.А."],
              volume: 11
            },
          {
              id: "194",
              name_ru: 'Клад X в. с обрезанными куфическими монетами из Железногорского района Курской области',
              centuries: ['X'],
              authors: ["Гоглов С.А."],
              volume: 11
            },
          {
              id: "195",
              name_ru: 'Клады и курганные комплексы куфических монет Х – нач. XI вв., найденные или впервые изданные и пополненные в 2015–2021 гг., а также ранее неучтенные клады ХХ в.',
              centuries: ['X', 'XI'],
              authors: ["Лебедев В.П."],
              volume: 11
            },
          {
              id: "196",
              name_ru: 'Об отдельных группах подражаний средневековым западноевропейским монетам XI в. на землях Древней Руси (по сборам в России, Беларуси и Украине)',
              centuries: ['XI'],
              authors: ["Тигунцев Ю.Г."],
              volume: 11
            },
          {
              id: "197",
              name_ru: 'Серебряные брактеаты тмутараканского князя Романа Святославича (1068–1079 гг.)',
              centuries: ['X'],
              authors: ["Гарбузов В.Д."],
              volume: 11
            },
          {
              id: "198",
              name_ru: 'Новые находки древнерусских свинцовых пломб XI–XIV вв. на территории Беларуси, зафиксированные в 2020–2021 гг.',
              centuries: ['XI', 'XII', 'XIII', 'XIV'],
              authors: ["Богуш А.К."],
              volume: 11
            },
          {
              id: "199",
              name_ru: 'О древней топографии и новых находках древнерусских свинцовых пломб и вислой печати XII в. в г. Смоленск',
              centuries: ['XII'],
              authors: ["Марков В.В."],
              volume: 11
            },
          {
              id: "200",
              name_ru: 'Материалы к топографии находок древнерусских свинцовых пломб на территории Беларуси',
              centuries: ['XI', 'XII', 'XIII', 'XIV'],
              authors: ["Богуш А.К."],
              volume: 11
            },
          {
              id: "201",
              name_ru: 'Монетно-вещевой клад X в. с подражаниями куфическим дирхемам из Харьковской области',
              centuries: ['X'],
              authors: ["Гоглов С.А.", "Шапошник В.Г.", "Овсянников О.В."],
              volume: 12
            },
          {
              id: "202",
              name_ru: 'Луховицкий клад середины X в. из Московской обл.',
              centuries: ['X'],
              authors: ["Лебедев В.П.", "Амосов М.А."],
              volume: 12
            },
          {
              id: "203",
              name_ru: 'Клад куфических монет второй половины X в. из Смоленской обл.',
              centuries: ['X'],
              authors: ["Гоглов С.А.", "Овсянников О.В."],
              volume: 12
            },
          {
              id: "204",
              name_ru: 'Древнерусские свинцовые пломбы из окольного города древнего Гродно, хранящиеся в фондах Гродненского государственного историко-археологического музея',
              centuries: ['XII'],
              authors: ["Богуш А.К.", "Гулецкий Д.В.", "Спирин И.В."],
              volume: 12
            },
          {
              id: "205",
              name_ru: 'Печать княгини Марии',
              centuries: ['XIV'],
              authors: ["Гаев А.Г."],
              volume: 12
            },
          {
              id: "206",
              name_ru: 'Заметки по метрологии джучидских монет XIII в.',
              centuries: ['XIII'],
              authors: ["Бугарчёв А.И.", "Исаев В.Ю.", "Дзюба Ю.В.", "Емельянов В.П."],
              volume: 12
            },
            {
              id: "207",
              name_ru: 'О методах определения места выпуска «столичных» эмиссий золотоордынских монет. Чекан Хаджи-Тархана до 776 г.х.',
              centuries: ['XIV'],
              authors: ["Ермолов Ф.В.", "Леонов Б.И."],
              volume: 12
            },
            {
              id: "208",
              name_ru: 'Еще немного о чекане дангов хана Мухаммеда в 775–776 г.х.',
              centuries: ['XIV'],
              authors: ["Булава Л.Н.", "Шевчук А.А."],
              volume: 12
            },
            {
              id: "209",
              name_ru: 'Новые штемпельные связи крымских серебряных монет первой половины 80-х гг. XIV в.',
              centuries: ['XIV'],
              authors: ["Шапошник В.Г.", "Добромыслов Л.Б."],
              volume: 12
            },
            {
              id: "210",
              name_ru: 'Подражания Поочья: группа поокских подражаний, надчеканенных тамгой Великого княжества Рязанского',
              centuries: ['XIV', 'XV'],
              authors: ["Павлюков В.В."],
              volume: 12
            },
            {
              id: "211",
              name_ru: 'Клад серебряных монет и платежных слитков XIV в. из Харьковского Поудья',
              centuries: ['XIV'],
              authors: ["Шапошник В.Г.", "Зайцев В.В."],
              volume: 12
            },
            {
              id: "212",
              name_ru: 'Печерский клад клейменых платежных слитков из окрестностей Смоленска',
              centuries: ['XIV', 'XV'],
              authors: ["Зайцев В.В."],
              volume: 12
            },
            {
              id: "213",
              name_ru: 'Новгородский клад ливонских серебряных слитков с клеймами конца XIV – начала XV в.',
              centuries: ['XIV', 'XV'],
              authors: ["Зайцев В.В."],
              volume: 12
            },
            {
              id: "214",
              name_ru: 'Серебряные платежные слитки XIV−XV вв. с клеймами Великого княжества Тверского',
              centuries: ['XIV', 'XV'],
              authors: ["Зайцев В.В."],
              volume: 12
            },
            {
              id: "215",
              name_ru: 'Хроника интересных находок русских монет конца XIV – середины XV в.',
              centuries: ['XIV', 'XV'],
              authors: ["Титов Г.А."],
              volume: 12
            },
            {
              id: "216",
              name_ru: 'О денгах Петра Дмитриевича Дмитровского с изображением воина и строчной надписью',
              centuries: ['XV'],
              authors: ["Титов Г.А."],
              volume: 12
            },
            {
              id: "217",
              name_ru: '«Императорский» портрет на великокняжеских монетах',
              centuries: ['XV'],
              authors: ["Таценко С.Н."],
              volume: 12
            },
            {
              id: "218",
              name_ru: 'Новые находки денежных комплексов времени Василия III',
              centuries: ['XVI'],
              authors: ["Кудрашов Р.А.", "Моряков А.В."],
              volume: 12
            },
            {
              id: "219",
              name_ru: 'К вопросу о методике применения физико-химических методов анализа для исследований в области нумизматики (мультидисциплинарное исследование на примере медно-серебряных монет)',
              centuries: ['XVI'],
              authors: ["Морозов А.А.", "Набелкин О.А."],
              volume: 12
            },
            {
              id: "220",
              name_ru: 'Западноевропейские пломбы с изображением герба Англии и «Розы» династии Тюдоров из археологических раскопок в Москве',
              centuries: ['XVI'],
              authors: ["Петухов С.П."],
              volume: 12
            },
            {
              id: "221",
              name_ru: 'От полугроша к шиллингу. «Черные» шиллинги Риги 1623 года',
              centuries: ['XVII'],
              authors: ["Староверов Д.А.", "Безпалько В.В."],
              volume: 12
            },
            {
              id: "222",
              name_ru: 'Южнобалтийские и восточноевропейские клады куфических дирхамов как свидетельство военной активности данов из Трусо в Восточной Европе в 840-855 гг.',
              centuries: ['IX'],
              authors: ["Пашинский В.М."],
              volume: 13
            },
            {
              id: "223",
              name_ru: 'Обрезанные в круг куфические дирхемы (ветвь Радимичи-Киев) времени княжения Святослава Игоревича и его сына Ярополка - предтеча чекана сребренников Владимира Святославича',
              centuries: ['X'],
              authors: ["Лебедев В.П."],
              volume: 13
            },
            {
              id: "224",
              name_ru: 'Печати князей пригородов Новгорода Великого',
              centuries: ['XII', 'XIII', 'XIV', 'XV'],
              authors: ["Гаев А.Г."],
              volume: 13
            },
            {
              id: "225",
              name_ru: 'Находки вислых печатей XI-XIII вв., зафиксированные на территории Беларуси в 2020-2022 гг.',
              centuries: ['XI', 'XII', 'XIII'],
              authors: ["Богуш А.К."],
              volume: 13
            },
            {
              id: "226",
              name_ru: 'Новые данные о существовании денежного двора XII в. в Друцке',
              centuries: ['XII'],
              authors: ["Гулецкий Д.В."],
              volume: 13
            },
            {
              id: "227",
              name_ru: 'Віслыя пячаткі князя Яраполка (Пятра) Ізяславіча 1069–1086 гадоў',
              centuries: ['XI'],
              authors: ["Жуков И.А."],
              volume: 14
            },
            {
              id: "228",
              name_ru: 'Пячаткі і пломбы XI ст. з выявай св. пакутніка Фёдара',
              centuries: ['XI'],
              authors: ["Гулецкий Д.В.", "Яковлев А.В.", "Богуш А.К."],
              volume: 14
            },
            {
              id: "229",
              name_ru: 'Свінцовыя пячаткі XI – XII стст. з паўночна-заходняй часткі Чарнігаўскай зямлі (па зборах у Бранскай вобласці). Частка 3: пячаткі і пломбы з выявамі святых розных тыпаў і памераў',
              centuries: ['XI', 'XII'],
              authors: ["Тигунцев Ю.Г."],
              volume: 14
            },
            {
              id: "230",
              name_ru: 'Старажытнарускія свінцовыя пломбы XI-XIII стст. з тэрыторыі Друцкага княства',
              centuries: ['XI', 'XII', 'XIII'],
              authors: ["Богуш А.К."],
              volume: 14
            },
            {
              id: "231",
              name_ru: 'Да пытання аб пачатку абарачэння пражскіх грошаў на тэрыторыі Беларусі',
              centuries: ['XIV'],
              authors: ["Громыко А.А."],
              volume: 14
            },
            {
              id: "232",
              name_ru: 'Комплекс джучидських дангiв 1370-х рокiв з Зiнькiвського району ПолтавскоЇ областi',
              centuries: ['XIV'],
              authors: ["Шевчук А.А."],
              volume: 14
            },
            {
              id: "233",
              name_ru: 'Невеликий гаманець дангiв з-пiд мiста Богодухова Харківської області',
              centuries: ['XIV'],
              authors: ["Зайончковский Ю.В."],
              volume: 14
            },
            {
              id: "234",
              name_ru: 'Два переломных момента эпохи викингов как результат соперничества данов и свеонов. Балтийский перелом 830-х гг. (часть I)',
              centuries: ['IX'],
              authors: ["Пашинский В.М."],
              volume: 15
            },
            {
              id: "235",
              name_ru: 'К вопросу о месте чеканки «рунических» подражаний куфическим дирхемам',
              centuries: ['IX', 'X'],
              authors: ["Гоглов С.А."],
              volume: 15
            },
            {
              id: "236",
              name_ru: 'Свод нумизматических находок с арабскими надписями домонгольского периода (IX – X в.), обнаруженных в юго-западных районах Брянской области',
              centuries: ['IX', 'X'],
              authors: ["Тигунцев Ю.Г.", "Соболев В.В."],
              volume: 15
            },
            {
              id: "237",
              name_ru: 'Два комплекса второй половины X в. с обрезанными куфическими монетами из Курского района Курской области',
              centuries: ['X'],
              authors: ["Гоглов С.А.", "Лебедев В.П."],
              volume: 15
            },
            {
              id: "238",
              name_ru: 'Древнерусские пломбы XI-XII вв. из археологического комплекса на реке Менка',
              centuries: ['XI', 'XII'],
              authors: ["Войтехович А.В.", "Гулецкий Д.В."],
              volume: 15
            },
            {
              id: "239",
              name_ru: 'Древнерусские пломбы с территории средневековых Друцкого и Мстиславского княжеств',
              centuries: ['XI', 'XII', 'XIII'],
              authors: ["Богуш А.К."],
              volume: 15
            },
            {
              id: "240",
              name_ru: 'Древнерусские пломбы пломбы XI-XIII вв. с территории Черниговской области и Западной Украины',
              centuries: ['XI', 'XII', 'XIII'],
              authors: ["Богуш А.К."],
              volume: 15
            },
            {
              id: "241",
              name_ru: 'Позолоченная накладка с двуглавым орлом из Брянской области - западноевропейский экспорт?',
              centuries: ['XII', 'XIII'],
              authors: ["Тигунцев Ю.Г."],
              volume: 15
            },
            {
              "id": "242",
              "name_ru": "Анализ монетного сплава куфических подражаний «девицкой» серии второй четверти IX в.",
              "centuries": ["IX"],
              "authors": ["Гоглов С.А."],
              "volume": 16
            },
            {
              "id": "243",
              "name_ru": "Дополнения штемпельной сетки GGI-C3 (Rispling K101)",
              "centuries": ["X"],
              "authors": ["Гоглов С.А."],
              "volume": 16
            },
            {
              "id": "244",
              "name_ru": "Монетный комплекс обрезанных в круг дирхемов 70-х гг. Х в. из Поочья",
              "centuries": ["X"],
              "authors": ["Гоглов С.А.", "Лебедев В.П."],
              "volume": 16
            },
            {
              "id": "245",
              "name_ru": "К проблеме ранних самостоятельных княжений сыновей Всеслава Брячиславича (1044–1101): о предполагаемых атрибуции и датировке их первых актовых печатей",
              "centuries": ["XI"],
              "authors": ["Гулецкий Д.В."],
              "volume": 16
            },
            {
              "id": "246",
              "name_ru": "Древнерусские свинцовые пломбы из Дрогичина, хранящиеся в фондах Гродненского государственного историко-археологического музея",
              "centuries": ["XIII"],
              "authors": ["Богуш А.К."],
              "volume": 16
            },
            {
              "id": "247",
              "name_ru": "Древнерусские свинцовые пломбы с территории посада средневекового Друцка",
              "centuries": ["XI", "XII", "XIII"],
              "authors": ["Богуш А.К."],
              "volume": 16
            },
            {
              "id": "248",
              "name_ru": "Джучидские монеты XIII–XIV вв. с территории Салмановского археологического комплекса (материалы к нумизматическому паспорту Алькеевского района Татарстана)",
              "centuries": ["XIII", "XIV"],
              "authors": ["Бугарчёв А.И.", "Купцов А.Е."],
              "volume": 16
            },
            {
              "id": "249",
              "name_ru": "О начале монетной чеканки Мохши (новые данные)",
              "centuries": ["XIV"],
              "authors": ["Рева Р.Ю.", "Сычев Ю.В.", "Леонов Б.И."],
              "volume": 16
            },
            {
              "id": "250",
              "name_ru": "О раннем варианте сарайских пулов 737 г.х. / 1336–1337 гг. (тип «лев и полное солнце»)",
              "centuries": ["XIV"],
              "authors": ["Бугарчёв А.И.", "Федорова Е.А."],
              "volume": 16
            },
            {
              "id": "251",
              "name_ru": "Исследование монетного производства ханской Орды в период 792–794 гг.х.",
              "centuries": ["XIV"],
              "authors": ["Добромыслов Л.Б."],
              "volume": 16
            },
            {
              "id": "252",
              "name_ru": "Поражение Корибута в противостоянии с Витовтом – нумизматическое отражение",
              "centuries": ["XIV"],
              "authors": ["Зайцев В.В.", "Шапошник В.Г."],
              "volume": 16
            },
            {
              "id": "253",
              "name_ru": "Клад серебряных монет рубежа XIV и XV вв. из окрестностей древнего Любутска",
              "centuries": ["XIV", "XV"],
              "authors": ["Петрунин К.М.", "Зайцев В.В.", "Павлюков В.В.", "Шапошник В.Г."],
              "volume": 16
            },
            {
              "id": "254",
              "name_ru": "Джучидские монеты и подражания им из Любутского археологического комплекса",
              "centuries": ["XIV"],
              "authors": ["Болдин И.В.", "Шапошник В.Г."],
              "volume": 16
            },
            {
              "id": "255",
              "name_ru": "О новых находках смоленских монет начала XV в.",
              "centuries": ["XV"],
              "authors": ["Марков В.В.", "Поваренков А.В."],
              "volume": 16
            },
            {
              "id": "256",
              "name_ru": "О группе подражаний начала XV в., связанной с русским удельным чеканом",
              "centuries": ["XV"],
              "authors": ["Савоста Р.Ю.", "Шапошник В.Г."],
              "volume": 16
            },
            {
              "id": "257",
              "name_ru": "Полуденги Нижегородско-Суздальского княжества и пограничных с ним земель Великого княжества Московского",
              "centuries": ["XV"],
              "authors": ["Титов Г.А.", "Штрафметов А.Б."],
              "volume": 16
            },
            {
              "id": "258",
              "name_ru": "Клад конца правления великого князя Василия I из окрестностей Переславля-Залесского",
              "centuries": ["XV"],
              "authors": ["Титов Г.А.", "Шулепко М.И."],
              "volume": 16
            },
            {
              "id": "259",
              "name_ru": "География распространения монет Золотой Орды и Крыма XIV–XVI вв. на территории Беларуси (по материалам новых данных о находках)",
              "centuries": ["XIV","XV","XVI"],
              "authors": ["Горбань П.И."],
              "volume": 16
            },
            {
              "id": "260",
              "name_ru": "Каталог литовских монет 1495–1536 гг. и дополнения к нему",
              "centuries": ["XVI"],
              "authors": ["Гулецкий Д.В.", "Багдонас Г."],
              "volume": 16
            },
            {
              "id": "261",
              "name_ru": "Клад времени Василия III из деревни Старое Бобренево Московской области",
              "centuries": ["XVI"],
              "authors": ["Волков И.В.", "Петрунин К.М.", "Титов Г.А."],
              "volume": 16
            },
            {
              "id": "262",
              "name_ru": "Монеты с именем хана Саадата I Гирая (929–938 гг.х. / 1523–1532 гг.)",
              "centuries": ["XVI"],
              "authors": ["Морозов А.А."],
              "volume": 16
            },
            {
              "id": "263",
              "name_ru": "Часть клада из Евпатории (находка 1890-х гг)? Дополняя О.Ф. Ретовского",
              "centuries": ["XVII"],
              "authors": ["Морозов А.А.", "Крицук Р.И."],
              "volume": 16
            },
            {
              "id": "264",
              "name_ru": "Клад из урочища Самарово",
              "centuries": ["XVII"],
              "authors": ["Моряков А.В."],
              "volume": 16
            },
            {
              "id": "265",
              "name_ru": "О чем может рассказать свинцовая пломба XVIII в.",
              "centuries": ["XVIII"],
              "authors": ["Тигунцев Ю.Г."],
              "volume": 16
            },
            {
              "id": "266",
              "name_ru": "Весовые меры в торговой практике Античности и Средневековья. Метод грана. Реконструкция денежно-весовых систем Хорезма и Таны начала XIV века",
              "centuries": ["IX", "X", "XI", "XII", "XIII", "XIV"],
              "authors": ["Исаев В.Ю."],
              "volume": 17
            },
            {
              "id": "267",
              "name_ru": 'Два переломных момента эпохи викингов как результат соперничества данов и свеонов. Балтийский перелом 830-х гг. (часть II)',
              "centuries": ['IX'],
              "authors": ["Пашинский В.М."],
              "volume": 18
            },
            {
              "id": "268",
              "name_ru": "Анализ монетного сплава восточноевропейских куфических подражательных монет второй половины IX–X вв.",
              "centuries": ["IX", "X"],
              "authors": ["Гоглов С.А."],
              "volume": 18
            },
            {
              "id": "269",
              name_ru: 'Древнерусские пломбы XI-XII вв. из археологического комплекса на реке Менка, открытые в 2024–2025 гг.',
              centuries: ['XI', 'XII'],
              authors: ["Войтехович А.В.", "Гулецкий Д.В."],
              "volume": 18
            },
            {
              "id": "270",
              name_ru: 'Сфрагистические находки с селища у д. Тисковщина, хранящиеся в музейной комнате Столбцовской центральной районной библиотеки им. Я. Коласа',
              centuries: ['XI', 'XII'],
              authors: ["Богуш А.К.", "Гулецкий Д.В.", "Пятинкин К.П."],
              "volume": 18
            },
            {
              "id": "271",
              name_ru: 'Денежные свинцовые пломбы в Беларуси: новые находки',
              centuries: ['XI', 'XII'],
              authors: ["Богуш А.К."],
              "volume": 18
            },
            {
              "id": "272",
              name_ru: 'Особенности денежного обращения в землях Курской и Еголдаевой тьмы, Рыльского и Путивльского княжеств по нумизматическим находкам XIV–XV вв.',
              centuries: ['XIV', 'XV'],
              authors: ["Стародубцев Г.Ю."],
              "volume": 18
            },
            {
              id: "273",
              name_ru: 'Заметки к одному типу монетовидных изделий, называемых «мордовки»',
              centuries: ['XV','XVI','XVII'],
              authors: ["Тигунцев Ю.Г.", "Овсянников О.В."],
              volume: 18
            },
            {
              id: "274",
              name_ru: 'Берестейский монетный двор 1665–1666 гг. и его точное расположение',
              centuries: ['XVII'],
              authors: ["Волков Е.Г.", "Никитчик А.Д.", "Яцкевич Д.Л."],
              volume: 18
            }
];